/** Copyright (c) 2020 T.Rowe Price. All rights reserved. */
import { createSelector } from 'reselect';

export const getBucketRollData = (state) => state.bucketRollData;

export const getIsBucketRollPeriod = createSelector(
  getBucketRollData,
  (bucketRollData) => {
    const currentYear = new Date().getFullYear();
    const BEGIN_YEAR = currentYear + '-01-01T00:00:00.000+00:00'
    const startOfYearDate = new Date(BEGIN_YEAR);
    const currentDate = new Date();
    return currentDate > startOfYearDate && currentDate <= new Date(bucketRollData?.endDate)
  }
);
